/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import type { EmployeeDto } from '../models/EmployeeDto';
import type { UpdateEmployeeCommand } from '../models/UpdateEmployeeCommand';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable({
  providedIn: 'root',
})
export class EmployeesService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @param id 
     * @param version 
     * @returns EmployeeDto Success
     * @throws ApiError
     */
    public getVEmployees(
id: number,
version: string,
): Observable<EmployeeDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/v{version}/Employees/{id}',
            path: {
                'id': id,
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns EmployeeDto Success
     * @throws ApiError
     */
    public getVEmployees1(
version: string,
): Observable<Array<EmployeeDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/v{version}/Employees',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns EmployeeDto Success
     * @throws ApiError
     */
    public putVEmployees(
version: string,
requestBody?: UpdateEmployeeCommand,
): Observable<EmployeeDto> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/v{version}/Employees',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @returns EmployeeDto Success
     * @throws ApiError
     */
    public getVEmployeesMe(
version: string,
): Observable<EmployeeDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/v{version}/Employees/me',
            path: {
                'version': version,
            },
        });
    }

}
